import React, { useState, useEffect } from "react";
import { getProgrammesEng } from "../../contentful";
import TitleBar from "../TitleBar";
import Translator from "../i18n/Translator";
import "./ProgrammesStyles.scss";
import ProgrammeItem from "./ProgrammeItem";
import { FaSearch } from "react-icons/fa";
import Brochures from "../Brochures/Brochures";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [projectsToView, setProjectsToView] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getProgrammesEng().then((data) => {
      setProjectsToView(data);
      setProjects(data);
    });
  }, []);

  const handleSearch = (e) => {
    const q = e.target.value;
    setSearch(q);
  };

  useEffect(() => {
    if (!search) return setProjectsToView(projects);
    setProjectsToView([
      ...projects.filter((p) => {
        return p.fields?.titleNl
          ?.toLowerCase()
          .includes(
            search?.toLowerCase() ||
              p.fields?.titleFr?.toLowerCase().includes(search?.toLowerCase()) ||
              p.fields?.title?.toLowerCase().includes(search?.toLowerCase()),
          );
      }),
    ]);
  }, [search]);

  return (
    <div className='view'>
      <TitleBar title={<Translator path='Programmes' />} />
      <Brochures />
      <div className='programmes__search'>
        <input value={search} onChange={handleSearch} />
        <FaSearch color='steelblue' />
      </div>
      {projectsToView.map((project) => {
        return <ProgrammeItem key={project.fields.title} programme={project.fields} />;
      })}
    </div>
  );
};

export default Projects;
